export default {
    'en.audit_trail': require('../../../lang/en/audit_trail.php'),
    'en.fuel': require('../../../lang/en/fuel.php'),
    'en.loyalty': require('../../../lang/en/loyalty.php'),
    'en.model': require('../../../lang/en/model.php'),
    'en.ui': require('../../../lang/en/ui.php'),
    'en.validation': require('../../../lang/en/validation.php'),
    'en.general': require('../../../lang/en/general.php'),
    'en_sentinel.general': require('../../../lang/en_sentinel/general.php'),
    'en.pricebook': require('../../../lang/en/pricebook.php'),
    'en_sentinel.pricebook': require('../../../lang/en_sentinel/pricebook.php'),
    'en.hub_settings': require('../../../lang/en/hub_settings.php'),
    'en.tag': require('../../../lang/en/tag.php'),
    'en_sentinel.tag': require('../../../lang/en_sentinel/tag.php'),
    'en.category': require('../../../lang/en/category.php'),
    'en_sentinel.category': require('../../../lang/en_sentinel/category.php'),
    'en.product': require('../../../lang/en/product.php'),
    'en_sentinel.product': require('../../../lang/en_sentinel/product.php'),
    'en.report': require('../../../lang/en/report.php'),
    'en_sentinel.report': require('../../../lang/en_sentinel/report.php'),
    'en.outlet': require('../../../lang/en/outlet.php'),
    'en_sentinel.outlet': require('../../../lang/en_sentinel/outlet.php'),
    'en.station_pricebook': require('../../../lang/en/station_pricebook.php'),
    'en_sentinel.station_pricebook': require('../../../lang/en_sentinel/station_pricebook.php'),
    'en.royalty': require('../../../lang/en/royalty.php'),
    'en_sentinel.royalty': require('../../../lang/en_sentinel/royalty.php'),
    'en.dashboard': require('../../../lang/en/dashboard.php'),
    'en_sentinel.dashboard': require('../../../lang/en_sentinel/dashboard.php'),
    'en.staff': require('../../../lang/en/staff.php'),
    'en_sentinel.staff': require('../../../lang/en_sentinel/staff.php'),
    'en.central_settings': require('../../../lang/en/central_settings.php'),
    'en_sentinel.hub_settings': require('../../../lang/en_sentinel/hub_settings.php'),
    'en_sentinel.central_settings': require('../../../lang/en_sentinel/central_settings.php'),
};



// WEBPACK FOOTER //
// ./resources/assets/js/plugins/strings.js